var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivate({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.729,
    height: 32.729,
    viewBox: "0 0 32.729 32.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-activate-3451767",
    transform: "translate(-140.003 -70)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3551",
    "data-name": "Path 3551",
    d: "M369.546,332.5a2.056,2.056,0,0,0-2.046,2.046h1.364a.682.682,0,1,1,1.364,0v2.046h1.364v-2.046A2.056,2.056,0,0,0,369.546,332.5Z",
    transform: "translate(-209.769 -242.044)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3552",
    "data-name": "Path 3552",
    d: "M334.546,315a2.056,2.056,0,0,0-2.046,2.046h1.364a.682.682,0,1,1,1.364,0v3.409h1.364v-3.409A2.056,2.056,0,0,0,334.546,315Z",
    transform: "translate(-177.496 -225.908)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3553",
    "data-name": "Path 3553",
    d: "M264.546,350a2.056,2.056,0,0,0-2.046,2.046v5.114a3.757,3.757,0,0,0,3.75,3.75h.341v-1.364h-.341a2.367,2.367,0,0,1-2.387-2.387v-5.114a.682.682,0,0,1,1.364,0h1.364A2.056,2.056,0,0,0,264.546,350Z",
    transform: "translate(-112.951 -258.18)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3554",
    "data-name": "Path 3554",
    d: "M404.546,350a2.053,2.053,0,0,0-2.039,2.046h1.364a.675.675,0,1,1,1.35,0l.007,5.114a2.36,2.36,0,0,1-2.373,2.387H402.5v1.364h.354a3.751,3.751,0,0,0,3.737-3.75l-.007-5.113A2.053,2.053,0,0,0,404.546,350Z",
    transform: "translate(-242.042 -258.18)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3555",
    "data-name": "Path 3555",
    d: "M299.546,245a2.056,2.056,0,0,0-2.046,2.046v11.592h1.364V247.046a.682.682,0,1,1,1.364,0v8.864h1.364v-8.864A2.056,2.056,0,0,0,299.546,245Z",
    transform: "translate(-145.224 -161.363)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3556",
    "data-name": "Path 3556",
    d: "M302.147,174.916a.681.681,0,0,0-.469.206l-2.245,2.245-.882-.882h0a.682.682,0,1,0-.964.964l1.364,1.364a.681.681,0,0,0,.964,0l2.727-2.727a.682.682,0,0,0-.5-1.17Z",
    transform: "translate(-145.111 -96.74)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3557",
    "data-name": "Path 3557",
    d: "M490.667,87.366a.682.682,0,0,0-.671.693v2.707a.682.682,0,1,0,1.364,0V88.059a.682.682,0,0,0-.692-.693Z",
    transform: "translate(-322.719 -16.013)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3558",
    "data-name": "Path 3558",
    d: "M473.194,104.869a.682.682,0,1,0,0,1.364H475.9a.682.682,0,1,0,0-1.364Z",
    transform: "translate(-306.589 -32.152)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3559",
    "data-name": "Path 3559",
    d: "M158.167,140.179a.681.681,0,0,0-.671.692v2.708a.682.682,0,1,0,1.364,0v-2.708a.682.682,0,0,0-.693-.692Z",
    transform: "translate(-16.13 -64.71)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3560",
    "data-name": "Path 3560",
    d: "M140.694,157.669a.682.682,0,1,0,0,1.364H143.4a.682.682,0,1,0,0-1.364Z",
    transform: "translate(0 -80.837)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3561",
    "data-name": "Path 3561",
    d: "M456.364,175.682a.682.682,0,1,1-.682-.682A.682.682,0,0,1,456.364,175.682Z",
    transform: "translate(-290.45 -96.818)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3562",
    "data-name": "Path 3562",
    d: "M543.864,70.682a.682.682,0,1,1-.2-.482A.682.682,0,0,1,543.864,70.682Z",
    transform: "translate(-371.132)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3563",
    "data-name": "Path 3563",
    d: "M421.364,70.682a.682.682,0,1,1-.2-.482A.682.682,0,0,1,421.364,70.682Z",
    transform: "translate(-258.178)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3564",
    "data-name": "Path 3564",
    d: "M211.364,88.182a.682.682,0,1,1-.2-.482A.682.682,0,0,1,211.364,88.182Z",
    transform: "translate(-64.543 -16.136)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3565",
    "data-name": "Path 3565",
    d: "M193.864,245.682a.682.682,0,1,1-.2-.482A.682.682,0,0,1,193.864,245.682Z",
    transform: "translate(-48.406 -161.363)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3566",
    "data-name": "Path 3566",
    d: "M526.364,280.682a.682.682,0,1,1-.2-.482A.682.682,0,0,1,526.364,280.682Z",
    transform: "translate(-354.996 -193.635)",
    fill: "#f37320"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3567",
    "data-name": "Path 3567",
    d: "M251.817,122.48a.681.681,0,0,0-.244.045,6.827,6.827,0,0,0-6.125,4.6l0,.008a8.116,8.116,0,0,0,1.032,7.314h0a.682.682,0,1,0,1.135-.756,6.63,6.63,0,0,1-.878-6.111,5.452,5.452,0,0,1,5.071-3.732h.044a5.462,5.462,0,0,1,5.05,3.734,6.537,6.537,0,0,1-1.467,6.671h0a.682.682,0,1,0,.94.987,7.786,7.786,0,0,0,1.811-8.12,6.843,6.843,0,0,0-6.367-4.641Z",
    transform: "translate(-96.812 -48.39)",
    fill: "#f37320"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivate);
export default __webpack_public_path__ + "static/media/activate.818ef3c3843c4307e257034a3f0c831e.svg";
export { ForwardRef as ReactComponent };